import { QueryState } from 'common/enums';
import { Nullable } from 'common/utils/Nullable';

export interface ICreateNotificationContactState {
  state: QueryState;
  error: Nullable<string>;
  accessToken: string | undefined;
}

export const CreateNotificationContactEmptyState: ICreateNotificationContactState = {
  state: QueryState.UNDEFINED,
  error: null,
  accessToken: undefined
};
